import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=6bad3248&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"
import style0 from "./recommend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports